<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row>
          <b-col class="col-2">
            <strong>CN #</strong>
          </b-col>
          <b-col>{{ collection_note.cn_number }}</b-col>
        </b-row>
        <b-row>
          <b-col class="col-2">
            <strong>Vendor Name</strong>
          </b-col>
          <b-col>{{ collection_note.vendor_name }}</b-col>
        </b-row>
        
        <b-row>
          <b-col class="col-2">
            <strong>Vendor Address</strong>
          </b-col>
          <b-col>{{ collection_note.vendor_address }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Vendor Contact</strong>
          </b-col>
          <b-col>{{ collection_note.vendor_contact_person }}</b-col>
        </b-row>

        <b-row>
          <b-col class="col-2">
            <strong>Vendor Phone</strong>
          </b-col>
          <b-col>{{ collection_note.vendor_phone }}</b-col>
        </b-row>

        <b-row class="mt-1 mb-1">
            <b-col class="">

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="printNote()"
              >
                Print Collection Note
              </b-button>
            </b-col>
          </b-row>
      </b-card>

      <h4 class="mt-3">
        Orders
      </h4>

      <b-card>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="collection_note.orders"
          :fields="order_fields"
        >
          <template v-slot:cell(action)="data">
            <b-button
            v-if="data.item.status == 'pending'"
              class="btn-action"
              size="sm"
              variant="success"
              @click.stop="doReceiveOrder(data.item)"
              >Receive</b-button
            >
          </template>
        </b-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const order_fields = [
  {
    key: "order_number",
    label: "Order Number"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "DeliveryNoteDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      collection_note: {},
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Collection Note",
          to: { name: "collection_note" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      loader: false,
      collection_note_orders: [],
      order_fields: order_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0
    };
  },
  async created() {
    await this.getDeliveryNoteDetail();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getDeliveryNoteDetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_get.php",
        data: {
          collection_note_id: this.$route.params.collection_note_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if (response.data.collection_notes && response.data.collection_notes.length > 0) {
        this.collection_note = response.data.collection_notes[0];
      }

      this.loader.hide();
    },

    async doReceiveOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_note_order_receive.php",
        data: {
          collection_note_id: this.$route.params.collection_note_id,
          collection_note_order_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.getDeliveryNoteDetail();
    },

    async printNote() {

      this.$http({
          url: this.NODEJS_API_URL + "/gen_note",
          method: "POST",
          data: {
            note_id: this.$route.params.collection_note_id,
            note_type: 'collection'
          },
          responseType: "blob" // important
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "collection_note.pdf");
          document.body.appendChild(link);
          link.click();
        });
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectionNoteDetail.vue